/* eslint-disable no-param-reassign */
import Vue from 'vue';
import VueSession from 'vue-session';
import { PUBLIC_KEY_HEADER } from '@/utils/api';
import NodeRSA from 'node-rsa';

const key = new NodeRSA(PUBLIC_KEY_HEADER);
const SENSITIVE_KEY = ['userId', 'role', 'subPassword', 'password'];

const optionsSession = {
  persist: false,
};

Vue.use(VueSession, optionsSession);

Vue.filter('dateTimeFormatter', (unix) => {
  const t = new Date(unix);
  const zeroPad = (value: any, size: any): string => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value);
  return `${zeroPad(t.getFullYear(), 2)}-${zeroPad(t.getMonth() + 1, 2)}-${zeroPad(t.getDate(), 2)} ${zeroPad(t.getHours(), 2)}:${zeroPad(t.getMinutes(), 2)}:${zeroPad(t.getSeconds(), 2)}`;
});

Vue.filter('commaFormatter', (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

Vue.filter('upperCamel', (text) => text
  .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return '';
    return index === 0 ? match.toUpperCase() : match.toLowerCase();
  }));

export default {
  getUserPersistent() {
    if (Vue.prototype.$session) {
      if (!Vue.prototype.$session.get('ambgames-user-authenticate')) {
        return {
          user: {
            _id: null,
            username: null,
            type: null,
            nickname: null,
            source: null,
            level: null,
            wallet: null,
            commission: null,
            ipWhitelist: null,
            isFeature: null,
            isMechanic: null,
            showCurrencySigns: null,
          },
          token: '',
        };
      }
      return JSON.parse(Vue.prototype.$session.get('ambgames-user-authenticate'));
    } else {
      return {
        user: {
          _id: null,
          username: null,
          type: null,
          nickname: null,
          source: null,
          level: null,
          wallet: null,
          commission: null,
          ipWhitelist: null,
          isFeature: null,
          isMechanic: null,
          showCurrencySigns: null,
        },
        token: '',
      };
    }
  },
  clearUserPersistent() {
    Vue.prototype.$session.destroy('ambgames-user-refresh-token');
    Vue.prototype.$session.destroy('ambgames-user-access-token');
    Vue.prototype.$session.destroy('ambgames-user-authenticate');
    delete Vue.axios.defaults.headers.common.Authorization;
  },
  getUserBalance() {
    if (Vue.prototype.$session) {
      if (!Vue.prototype.$session.get('ambgames-user-balance')) {
        return 0;
      }
      return Vue.prototype.$session.get('ambgames-user-balance');
    }
  },
  currencyFormatter(balance: number) {
    const x = balance;
    if (x === 0) {
      return '0.00';
    } else if (!x) {
      return x;
    }
    return x.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  },

  balanceFormatter(balance: number) {
    if (balance === 0) {
      return '0.00';
    } else if (balance === null || balance === undefined) {
      return balance;
    }

    const splitBalance = balance.toString().split('.');
    const lengthBalance = splitBalance[1] ? splitBalance[1].length : 0;

    let formattedBalance;
    if (lengthBalance >= 3) {
      formattedBalance = balance.toFixed(3);
    } else if (lengthBalance === 1) {
      formattedBalance = balance.toFixed(2);
    } else {
      formattedBalance = balance.toFixed(2);
    }

    return formattedBalance.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  colorCurrency(value) {
    if (value < 0) return 'red-text';
    return '';
  },
  colorCurrencyLog(value) {
    if (value > 0) return 'green-text';
    if (value < 0) return 'red-text';
    return '';
  },
  colorCurrencyFoot(val) {
    if (val < 0) return 'red-text-foot';
    return '';
  },
  colorWinloss(value) {
    if (value > 0) return 'green-text';
    if (value < 0) return 'red-text';
    return 'blue-text';
  },
  winloseStatus(value) {
    if (value > 0) return 'Win';
    if (value < 0) return 'Loss';
    return 'Tie';
  },
  getRefreshToken() {
    return Vue.prototype.$session.get('ambgames-user-refresh-token');
  },
  encryptAES(subPassword) {
    return this.encrypt(subPassword);
  },
  encryptAESHeader() {
    const text = 'b34f63f8733328b5c6c9a98354f70137';
    return this.encrypt(text);
  },
  encryptSensitiveData(request) {
    for (let i = 0; i < Object.keys(request).length; i += 1) {
      const data = Object.keys(request)[i];
      if (SENSITIVE_KEY.includes(data)) {
        request = Object.assign(request, { [`${data}`]: this.encrypt(request[data]) });
      }
    }
    return request;
  },
  encrypt(data) {
    return key.encrypt(data, 'base64');
  },
};
